import React from 'react';
import { DropdownSelect } from '../../../../components/Dropdown';
import { BasePdfComponent, PdfComponentType, PdfRepeat } from '../../PdfComponent';
import { usePdfTemplateContext } from '../../PdfTemplateEditorContext';

export default function PdfTemplateComponentRepeat<T>({ component }: { component: BasePdfComponent }) {
  const { updateComponent } = usePdfTemplateContext<T>();

  const modes = [PdfRepeat.always, PdfRepeat.first, PdfRepeat.last];
  if (component.type === PdfComponentType.image) {
    modes.push(PdfRepeat.attachment);
  }

  return (
    <DropdownSelect<PdfRepeat>
      label={'Repeat mode'}
      items={modes}
      textBuilder={m => m}
      value={component.repeatMode}
      onSelect={m => updateComponent(component.id, { repeatMode: m })}
    />
  );
}
